"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var _product = require("@/api/product");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: "showDetail",
  props: {
    user: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    formType: {
      type: String,
      default: function _default() {
        return 'detail';
      }
    },
    visible: {
      type: Boolean,
      default: function _default() {
        false;
      }
    }
  },
  data: function data() {
    return {
      formValidate: {},
      loading: false,
      productList: []
    };
  },
  mounted: function mounted() {
    this.formValidate = JSON.parse(JSON.stringify(this.user));
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      (0, _product.getProductList)({
        page: 1,
        limit: 500
      }).then(function (res) {
        _this.productList = res.data;
      }).catch(function () {});
    },
    resetForm: function resetForm(formName) {
      this.$emit("cancel");
    },
    submitForm: (0, _validate.Debounce)(function (formName) {
      var _this2 = this;
      this.$refs.user.validate(function (valid) {
        if (valid) {
          var _this2$formValidate = _this2.formValidate,
            id = _this2$formValidate.id,
            product_id = _this2$formValidate.product_id,
            type = _this2$formValidate.type,
            jcdw = _this2$formValidate.jcdw,
            pcdw = _this2$formValidate.pcdw,
            wtye = _this2$formValidate.wtye,
            time = _this2$formValidate.time;
          _this2.loading = true;
          (0, _product.updateUserProductOrder)({
            id: id,
            product_id: product_id,
            type: type,
            jcdw: jcdw,
            pcdw: pcdw,
            wtye: wtye,
            time: time
          }).then(function (res) {
            _this2.$message.success(_this2.$t('xgcg'));
            _this2.$emit("cancel");
          }).catch(function () {
            _this2.listLoading = false;
          });
        } else {
          return false;
        }
      });
    })
  }
};
exports.default = _default2;